import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import FileUpload from "../../components/FileUpload";

const empty = {
  bannerUrl: "",
  eyebrow: "Welcome to Kids Mode",
  title: "Stories that spark joy.",
  subtitle: "A safe space full of cartoons, learning shows and family adventures.",
};

export default function AdminSettings() {
  const [kids, setKids] = useState(empty);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/kids").then((r) => {
      setKids({ ...empty, ...r.data });
      setLoading(false);
    });
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings/kids", kids);
      toast.success("Kids page settings saved");
    } catch (e) {
      toast.error("Save failed: " + (e.response?.data?.detail || e.message));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-[#888]">Loading...</div>;

  return (
    <div data-testid="admin-settings-page">
      <div className="mb-8">
        <span className="text-xs font-bold text-[#E50914] uppercase tracking-[0.3em]">Site customization</span>
        <h1 className="text-4xl font-black tracking-tighter" style={{ fontFamily: "Outfit" }}>Site Settings</h1>
        <p className="text-[#888] text-sm mt-1">Customize hero banners and copy on key pages.</p>
      </div>

      <div className="bg-[#0d0d0d] border border-white/5 rounded-2xl p-6 max-w-2xl">
        <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: "Outfit" }}>Kids page hero</h2>

        <div className="space-y-4">
          <FileUpload
            label="Banner image (wide)"
            value={kids.bannerUrl}
            onChange={(v) => setKids({ ...kids, bannerUrl: v })}
            accept="image/*"
            kind="image"
          />
          <div>
            <label className="text-xs uppercase tracking-wider text-[#888] block mb-1.5">Eyebrow text</label>
            <input value={kids.eyebrow} onChange={(e) => setKids({ ...kids, eyebrow: e.target.value })} className="w-full px-3 py-2 bg-[#1a1a1a] border border-white/10 rounded-md text-sm focus:outline-none focus:border-[#E50914]" data-testid="kids-eyebrow-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#888] block mb-1.5">Title</label>
            <input value={kids.title} onChange={(e) => setKids({ ...kids, title: e.target.value })} className="w-full px-3 py-2 bg-[#1a1a1a] border border-white/10 rounded-md text-sm focus:outline-none focus:border-[#E50914]" data-testid="kids-title-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#888] block mb-1.5">Subtitle</label>
            <textarea rows="3" value={kids.subtitle} onChange={(e) => setKids({ ...kids, subtitle: e.target.value })} className="w-full px-3 py-2 bg-[#1a1a1a] border border-white/10 rounded-md text-sm focus:outline-none focus:border-[#E50914]" data-testid="kids-subtitle-input" />
          </div>
        </div>

        <div className="mt-5 flex justify-end">
          <button onClick={save} disabled={saving} className="btn-primary" data-testid="save-kids-settings-btn">
            {saving ? <><Loader2 className="animate-spin" size={16} /> Saving...</> : <><Save size={16} /> Save changes</>}
          </button>
        </div>
      </div>
    </div>
  );
}
